import React from "react";
import { LottiePlayer } from "../../../lottie-player/LottiePlayer";
import { Header, SlideLayout, Text } from "../../shared-components";
import { IconVariant } from "../../shared-components/Header";
import defragEventAnimation from "./assets/defrag-event.lottie";
export const DownloadClockwiseSlide = ({ browser }: { browser: string }) => {
  return (
    <SlideLayout>
      <Header iconVariant={IconVariant.Arrow}> Download Clockwise for {browser}</Header>
      <Text>
        Our Chrome extension allows you to access Clockwise in your daily workflows, without ever
        having to leave your calendar.
      </Text>
      <LottiePlayer
        className="cw-mt-6 md:cw-mt-0 cw-w-full cw-h-full md:cw-h-[450px] cw-pb-16 md:cw-pb-0"
        autoplay
        loop
        src={defragEventAnimation}
      />
    </SlideLayout>
  );
};
